import { render, staticRenderFns } from "./CustomInput.vue?vue&type=template&id=38c67bef&scoped=true"
import script from "./CustomInput.vue?vue&type=script&lang=js"
export * from "./CustomInput.vue?vue&type=script&lang=js"
import style0 from "./CustomInput.vue?vue&type=style&index=0&id=38c67bef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c67bef",
  null
  
)

export default component.exports